const PUBLIC_NO_TRACKING_ROUTE_PREFIX = "/externalBulkOrders/";

// The token is part of the URL path, so GA4/Crisp must never see this route — they'd leak it to third parties.
export function isPublicNoTrackingRoute(): boolean {
  return window.location.pathname.startsWith(PUBLIC_NO_TRACKING_ROUTE_PREFIX);
}
